import React, {useEffect, useState} from 'react';
import {Button, Col, Form, message, Row, Select, Input, Checkbox, Image, Upload, Tooltip} from "antd";
import './index.css'
import { useSelector,useDispatch } from 'react-redux';
import {setAllContextMeta, setRememberSvg} from "../../../../store/modules/user";
import {setContextMeta, hyperChatUploadImage, getAllContextMeta} from "../../../../api/other";

//设置
const SettingApp =(props)=>{
    //父组件传输
    const {handleCloseModel,handleOk} = props
    var {allContextMeta,rememberSvg} = useSelector(state => state.user)
    var {analysis_meta} = allContextMeta
    const dispatch = useDispatch()

    const selectResponderList = ()=>{
        let data = []
        analysis_meta.responder_list.map(res=>{
            data.push({label:res,value:res})
        })
        return data
    }
    //form组件
    const [form] = Form.useForm();
    const onFinish = (values) => {
        setContextMeta({
            "scenario": "analysis",
            "context_id": analysis_meta.context_id,
            "context_title": "",
            "context_group": "",
            "responder": values.responder,
            "responder_avatar": img,
            "system_prompt": "",
            "memory_rounds": 1
        }).then(res=>{
            if(res.code === 200){
                message.success('更新成功')
                let rs = checkedValue?'show':'hidden'
                dispatch(setRememberSvg(rs))
                getAllContextMeta().then(res=>{
                    if(res.code === 200){
                        dispatch(setAllContextMeta(res.data))
                    }
                })
                handleOk()
            }
        })

    };
    const [checkedValue,setCheckedValue] = useState(rememberSvg==='show'?true:false)
    const [img,setImg] = useState(analysis_meta.responder_avatar)
    const handleCheckChange = (e)=>{
        setCheckedValue(e.target.checked)
    }
    //校验失败
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    //更新头像
    const propsUpload = {
        beforeUpload: async(file) => {
            await hyperChatUploadImage({file}).then(res=>{
                if(res.code === 200){
                    setImg(res?.data.img_url)
                }
            })
            return Upload.LIST_IGNORE;
        }
    };
    return (
        <div className="SettingApp">
                <Form onFinish={onFinish} onFinishFailed={onFinishFailed} form={form} initialValues={{responder:analysis_meta.responder}}>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={18}>
                            <div className='fL'>语境名称</div>
                            <div>
                                <Input placeholder={'请输入名称'} value={'语法分析(不可修改)'} disabled={true} />
                            </div>
                        </Col>
                        <Col className="gutter-row" span={6}>
                            <div className='fL textCenter'>个性头像</div>
                            <div>
                                <Upload {...propsUpload}>
                                    <Tooltip placement="bottom" title={'修改'}>
                                    	<Image className={'hover'} src={img} width={50} height={50} style={{borderRadius:'50px'}} preview={false}></Image>
                                    </Tooltip>
                                </Upload>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={18}>
                            <div className='fL'>对话模型</div>
                            <div>
                                <Form.Item label="" name="responder">
                                    <Select
                                        style={{
                                            width: '100%',
                                        }}
                                        options={selectResponderList()}
                                    />
                                </Form.Item>
                            </div>
                        </Col>
                        <Col className="gutter-row" span={6}>
                            <div className='fL textCenter'>记忆窗口</div>
                            <div>
                                <Input placeholder={'请输入名称'} value={'1'} disabled={true} />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            显示注音 <Checkbox onChange={handleCheckChange} checked={checkedValue}></Checkbox>
                        </Col>
                    </Row>
                    <Form.Item>
                        <div className='textRight'>
                            <Button className='selfBtn' htmlType="submit">
                                确定
                            </Button>
                            <Button className='selfBtn btn2' onClick={handleCloseModel}>
                                取消
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
        </div>
    )
}

export default SettingApp
